import { useSelector } from 'react-redux'
import { loadedBotDeployabilityStatusSelector } from '../selectors'

export function useLoadedBotDeployabilityStatus() {
  return useSelector(loadedBotDeployabilityStatusSelector)
}
